import { Button, Form, ListGroup, Modal, Spinner } from "react-bootstrap";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { userSignal } from "../../../signal/userSignal";
import MapModal from "../maps/MapModal";
import Select from 'react-select';
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { dealerSignal } from "../../../signal/dealerSignal";
import * as moment from "moment";

export default function PaymentAddEditModal(props) {

    const [payment, setPayments] = useState(props?.payment ? props?.payment : {
        paymentType: "",
        remark: "",
        userId: "",
        managerId: "",
        dealerId: "",
        remark: "",
        amount: 0,
        media: [],
        createdAt: moment().valueOf()
    })
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        if (props?.payment) {
            setEdit(true)
            let pymt = props?.payment;
            pymt.userId = props?.payment?.userId?.length ? props?.payment?.userId[0].id : "";
            pymt.managerId = props?.payment?.userId?.length ? props?.payment?.userId[0].managerId : "";
            pymt.dealerId = props?.payment?.dealerId?.length ? props?.payment?.dealerId[0].id : "";
            setPayments({...pymt})
        }
    }, [props])

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                if (data?.data?.data?.length > 0) {
                    let medias = payment?.media || [];
                    data.data.data.map((item) => {
                        medias.push(item)
                    })
                    setPayments({ ...payment, media: medias })
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleImageUpload = (e) => {
        let data = new FormData();
        for (let i = 0; i < e.target.files?.length; i++) {
            data.append("media", e.target.files[i])
        }
        imageUploadMutation.mutate(data)
    }

    const addPaymentMutation = useMutation((body) => axios.post(`${DEV_SERVER}/payment/v2`, body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },

    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.close();
                props?.refetchPayments();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const handleAddPayment = () => {
        if (payment.paymentType === "") {
            toast.error("Payment Type is required");
            return;
        }

        if (payment.amount === "" || payment.amount === 0) {
            toast.error("Amount is required");
            return;
        }

        if (payment.dealerId === "") {
            toast.error("Dealer is required");
            return;
        }

        if (payment.userId === "") {
            toast.error("Assigned Employee is required");
            return;
        }

        let body = { ...payment }
        if (body.amount === "" || body.amount === NaN) {
            delete body.amount
        } else {
            body.amount = parseInt(body.amount)
        }
        addPaymentMutation.mutate(body);
    }

    const editPaymentMutation = useMutation((body) => axios.put(`${DEV_SERVER}/payment/v2/${body.id}`, body.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.close();
                props?.refetchPayments();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const handleEditPayment = () => {
        if (payment.paymentType === "") {
            toast.error("Payment Type is required");
            return;
        }

        if (payment.amount === "" || payment.amount === 0) {
            toast.error("Amount is required");
            return;
        }

        if (payment.dealerId === "") {
            toast.error("Dealer is required");
            return;
        }

        if (payment.userId === "") {
            toast.error("Assigned Employee is required");
            return;
        }

        let body = { ...payment }
        if (body.amount === "" || body.amount === NaN) {
            delete body.amount
        } else {
            body.amount = parseInt(body.amount)
        }
        editPaymentMutation.mutate({
            body: body,
            id: payment._id
        });
    }

    return (
        <Modal fullscreen show={props?.show} onHide={() => props?.close()}>
            <Modal.Header closeButton>
                <Modal.Title>Add Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form className="d-flex flex-wrap justify-content-center align-items-center" style={{ rowGap: "1rem", columnGap: "1rem", gridTemplateColumns: "0.5fr 0.5fr" }}>

                    <Form.Group className="mb-3 col-4" controlId="formBasicDate">
                        <Form.Label>Date</Form.Label>
                        <Form.Control value={moment(payment?.createdAt).format("YYYY-MM-DD")} onChange={(e) => setPayments({ ...payment, createdAt: moment(e.target.value).valueOf() })} type="date" placeholder="Enter Date" />
                    </Form.Group>

                    {/* <div></div> */}
                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Dealer</Form.Label>
                        <Select
                            options={Object.keys(dealerSignal?.value).map((key) => {
                                return {
                                    label: dealerSignal?.value[key]?.name,
                                    value: key
                                }
                            })}
                            value={payment?.dealerId ? { label: dealerSignal?.value[payment?.dealerId]?.name, value: payment?.dealerId } : null}
                            onChange={(e) => {
                                if (e && e?.value) {
                                    setPayments({ ...payment, dealerId: e?.value })
                                } else {
                                    setPayments({ ...payment, dealerId: "" })
                                }
                            }}

                            isClearable
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>User</Form.Label>
                        <Select
                            options={Object.keys(allUsersSignal?.value).map((key) => {
                                return {
                                    label: allUsersSignal?.value[key]?.name,
                                    value: key
                                }
                            })}
                            value={payment?.userId ? { label: allUsersSignal?.value[payment?.userId]?.name, value: payment?.userId } : null}
                            onChange={(e) => {
                                if (e && e?.value) {
                                    let usr = allUsersSignal.value[e?.value]
                                    setPayments({ ...payment, userId: e?.value, managerId: usr?.managerId })
                                } else {
                                    setPayments({ ...payment, userId: "", managerId: "" })
                                }
                            }}

                            isClearable
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Payment Type</Form.Label>
                        <Select
                            options={[
                                { label: "Cash", value: "Cash" },
                                { label: "Cheque", value: "Cheque" },
                                { label: "Bank Transfer", value: "Bank Transfer" },
                                { label: "UPI", value: "UPI" },
                                { label: "Angadiya", value: "Angadiya" },
                                { label: "Other", value: "other" }
                                ]    
                            }
                            value={payment?.paymentType ? { label: payment?.paymentType, value: payment?.paymentType } : null}
                            onChange={(e) => {
                                if (e && e?.value) {
                                    setPayments({ ...payment, paymentType: e?.value })
                                } else {
                                    setPayments({ ...payment, paymentType: "" })
                                }
                            }}

                            isClearable
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicGSTIN">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control value={payment?.amount} onChange={(e) => setPayments({ ...payment, amount: parseFloat(e.target.value) })} type="number" placeholder="Enter Amount" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicGSTIN">
                        <Form.Label>Remark</Form.Label>
                        <Form.Control value={payment?.remark} onChange={(e) => setPayments({ ...payment, remark: e.target.value })} type="text" placeholder="Enter Remark" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicImages">
                        <Form.Label>Media</Form.Label>
                        <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ columnGap: "0.5rem" }}>
                            {payment?.media?.length ? payment?.media.map((item, i) => {
                                return <div key={i} className="mt-3" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                    <img
                                        style={{ height: "100%", width: "100%" }}
                                        className="d-block w-100"
                                        src={item.url}
                                        alt="First slide"
                                    />
                                    <span onClick={() => {
                                        let images = payment?.media;
                                        images.splice(i, 1);
                                        setPayments({ ...payment, media: images })
                                    }} className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                        <i style={{ cursor: "pointer" }} className="fas fa-times"></i>
                                        <span className="visually-hidden">unread messages</span>
                                    </span>
                                </div>
                            }) : <></>}
                            <button disabled={imageUploadMutation.isLoading} className="btn btn-primary mt-3 d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                <i className="fas fa-upload"></i>
                                <input onClick={(e) => { e.target.value = null }} onChange={(e) => handleImageUpload(e)} type="file" multiple style={{ width: "50px", height: "50px", position: "absolute", top: "0", left: "0", opacity: "0", cursor: "pointer" }} />
                            </button>
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                {edit ? <Button disabled={editPaymentMutation.isLoading || imageUploadMutation.isLoading} variant="primary" onClick={() => handleEditPayment()}>
                    {(editPaymentMutation.isLoading || imageUploadMutation.isLoading) ? <Spinner animation="border" size="sm" /> : "Edit"}</Button>
                    :
                    <Button disabled={addPaymentMutation.isLoading || imageUploadMutation.isLoading} variant="primary" onClick={() => handleAddPayment()}>
                        {(addPaymentMutation.isLoading || imageUploadMutation.isLoading) ? <Spinner animation="border" size="sm" /> : "Add"}
                    </Button>
                }
                <Button variant="secondary" onClick={() => props?.close()}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}